<template>
  <div class="total-earnings-of-year bg-white px-4 py-4">
    <div class="heading flex flex-no-wrap flex-row justify-between mb-2">
      <h2 class="text-gray-500 text-sm">Total earnings of the {{filter}}</h2>
      <div class="filters flex flex-row flex-no-wrap justify-between">
        <span class="text-xs text-gray-500 tracking-wider cursor-pointer" :class="{'text-blue-500 underline': filter === 'week'}" @click="fetchChartData('week')">Week</span>
        <span class="text-xs text-gray-500 tracking-wider cursor-pointer" :class="{'text-blue-500 underline': filter === 'month'}" @click="fetchChartData('month')">Month</span>
        <span class="text-xs text-gray-500 tracking-wider cursor-pointer" :class="{'text-blue-500 underline': filter === 'year'}" @click="fetchChartData('year')">Year</span>
      </div>
    </div>
    <div>
      <GChart
        style="width: 100%;"
        type="LineChart"
        :data="chartData"
        :options="chartOptions"
        @ready="loading = false"
      />
    </div>
  </div>
</template>

<script>
import { GChart } from 'vue-google-charts';

export default {
  name: 'total_earnings',
  components: {
    GChart,
  },
  data() {
    return {
      loading: true,
      filter: 'week',
      chartOptions: {
        curveType: 'function',
        legend: { position: 'none' },
        chartArea: {
          left: '6%',
          width: '100%',
          height: '80%',
        },
        hAxis: {
          minValue: 0,
          textPosition: 'out',
        },
        vAxis: {
          minValue: 0,
          baselineColor: 'none',
          gridlines: {
            color: '#f2f2f2',
          },
        },
        animation: {
          duration: 1000,
          easing: 'out',
        },
      },
      chartEvents: {
        error: () => {
          this.loading = true;
        },
      },
    };
  },
  computed: {
    chartData() {
      switch (this.filter) {
        case 'week':
          return this.$store.getters['Dashboard/weekEarningsChartData'];
        case 'month':
          return this.$store.getters['Dashboard/monthEarningsChartData'];
        default:
          return this.$store.getters['Dashboard/yearEarningsChartData'];
      }
    },
  },
  methods: {
    async fetchChartData(type) {
      switch (type) {
        case 'week':
          this.loading = true;
          this.filter = 'week';
          await this.$store.dispatch('Dashboard/fetchWeekEarnings');
          break;
        case 'month':
          this.loading = true;
          this.filter = 'month';
          await this.$store.dispatch('Dashboard/fetchMonthEarnings');
          break;
        default:
          this.loading = true;
          this.filter = 'year';
          await this.$store.dispatch('Dashboard/fetchYearEarnings');
          break;
      }
    },
  },
  async mounted() {
    await this.fetchChartData('week');
  },
};
</script>

<style scoped lang="scss">
.total-earnings-of-year {
  height: auto;
}
.heading {
  flex: 0 1 69%
}
.filters {
  flex: 0 1 30%;
}
</style>
